<template>
<loader v-bind="{ loading }">
  <columns>
    <column>
      <form>
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <submit-button @submit="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </submit-button>
            </div>
          </template>
        </text-input>
      </form>
    </column>
    <column class="is-narrow is-flex align-end">
      <div class="buttons has-addons is-rounded">
        <router-link 
          class="button is-small is-rounded"
          :to="{ name: 'create-attribute-type' }">
          <icon icon="plus"/>
          <span>Attribute Type</span>
        </router-link>
        <router-link 
          class="button is-small is-rounded"
          :to="{ name: 'check-builder' }">
          <icon icon="plus"/>
          <span>Scraper</span>
        </router-link>
      </div>
    </column>
  </columns>
  
  <table class="table is-fullwidth is-hoverable">
    <thead>
      <tr>
        <th>Meta</th>
        <th>Type</th>
        <th>Published</th>
        <th>Scrapers</th>
        <th>Assessors</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="attributeType in attributeTypes.data" :key="attributeType.id">
        <td>
          <router-link :to="{
            name: 'attribute-type-manager',
            params: {
              attributeType: attributeType.id
            }
          }">
            {{ attributeType.title }}
          </router-link>                
        </td>
        <td>
          {{ attributeType.type | ucwords }}
        </td>
        <td>
          <yes-no :value="attributeType.published"/>
        </td>
        <td>
          {{ attributeType.scrapers_count }}
        </td>
        <td>
          {{ attributeType.assessors_count }}
        </td>
      </tr>
    </tbody>
  </table>

  <pager
    v-if="attributeTypes.data.length"
    class="mb-1"
    :pageable="attributeTypes" 
    @nav="goToPage"
    jump-controls
    context="App Meta"
  />

  <p v-else class="has-text-centered">No Attributes to Display</p>  
 </loader>
</template>
<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'
import { mapGetters } from 'vuex'

export default {

  name: 'App_Attributes',

  data: () => ({
    attributeTypes: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadAttributeTypes()
  },

  methods: {
    loadAttributeTypes() {
      this.loading = true
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.attributeTypes = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      this.$router.push({
        name: 'attribute-types',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'attribute-types',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  computed: {
    ...mapGetters('attributeType', [
      'types'
    ]),
  },

  watch: {
    '$route': 'loadAttributeTypes'
  }

}
</script>
